import { Injectable } from '@angular/core';
import { MeteringPointDto, MeteringPointService } from '@app/api/dmc';
import { ConnectionPointService, ConnectionPointDto } from '@app/api/nts';
import { Observable, of, shareReplay } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StateManagerService {
  private connectionPoint?: ConnectionPointDto;
  private meteringPoint?: MeteringPointDto;

  // Track in-flight requests
  private connectionPointRequest?: Observable<ConnectionPointDto>;
  private meteringPointRequest?: Observable<MeteringPointDto>;

  constructor(
    private readonly connectionPointService: ConnectionPointService,
    private readonly meteringPointService: MeteringPointService,
  ) { }

  public getConnectionPoint(id: string, force = false): Observable<ConnectionPointDto> {
    // If we already have data and no force refresh, return it
    if (this.connectionPoint?.id === id && !force) {
      return of(this.connectionPoint);
    }

    // If there's already an in-flight request for this ID, return it
    if (this.connectionPointRequest && this.connectionPoint?.id !== id) {
      return this.connectionPointRequest;
    }

    // Create a new request, share it, and store it
    this.connectionPointRequest = this.connectionPointService.connectionPointGetGet(id).pipe(
      tap(connectionPoint => {
        this.connectionPoint = connectionPoint;
        // Clear the stored request after completion
        this.connectionPointRequest = undefined;
      }),
      // shareReplay(1) ensures the result is shared with all subscribers
      // and replays the latest value to late subscribers
      shareReplay(1)
    );

    return this.connectionPointRequest;
  }

  public getMeteringPoint(id: string, force = false): Observable<MeteringPointDto> {
    // If we already have data and no force refresh, return it
    if (this.meteringPoint?.identification === id && !force) {
      return of(this.meteringPoint);
    }

    // If there's already an in-flight request for this ID, return it
    if (this.meteringPointRequest && this.meteringPoint?.id !== id) {
      return this.meteringPointRequest;
    }

    // Create a new request, share it, and store it
    this.meteringPointRequest = this.meteringPointService.meteringPointGetByIdentificationGet(id).pipe(
      tap(meteringPoint => {
        this.meteringPoint = meteringPoint;
        // Clear the stored request after completion
        this.meteringPointRequest = undefined;
      }),
      shareReplay(1)
    );

    return this.meteringPointRequest;
  }
}
